export const UpgradeSuperType = 'Upgrade';
export var UpgradeType;
(function (UpgradeType) {
    UpgradeType[UpgradeType["BattleFormation"] = 0] = "BattleFormation";
    UpgradeType[UpgradeType["SpellLore"] = 1] = "SpellLore";
    UpgradeType[UpgradeType["ManifestationLore"] = 2] = "ManifestationLore";
    UpgradeType[UpgradeType["BattleTrait"] = 3] = "BattleTrait";
    UpgradeType[UpgradeType["PrayerLore"] = 4] = "PrayerLore";
    UpgradeType[UpgradeType["RegimentOfRenown"] = 5] = "RegimentOfRenown";
    UpgradeType[UpgradeType["Enhancement"] = 6] = "Enhancement";
    UpgradeType[UpgradeType["Unknown"] = 99] = "Unknown";
})(UpgradeType || (UpgradeType = {}));
export const upgradeTypeToString = (type) => {
    switch (type) {
        case UpgradeType.BattleFormation:
            return 'Battle Formation';
        case UpgradeType.SpellLore:
            return 'Spell Lore';
        case UpgradeType.ManifestationLore:
            return 'Manifestation Lore';
        case UpgradeType.BattleTrait:
            return 'Battle Trait';
        case UpgradeType.PrayerLore:
            return 'Prayer Lore';
        case UpgradeType.RegimentOfRenown:
            return 'Regiment of Renown';
        case UpgradeType.Enhancement:
            return 'Enhancement';
        default:
            return 'Unknown';
    }
};
